module.exports = __webpack_public_path__ + "static/media/3.14c9e83e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instructorsPhoto/3.jpg
// module id = 244
// module chunks = 1